import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import {
  create_product_transection,
  getProductMaster,
  get_product_ingredients
} from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";

export const EditEndProductTransaction = ({
  showModal,
  setShowModal,
  fetchProducts,
  selectedProduct,
  AddorEdit,
  setCurrentPage,
}) => {
  const { showLoader, hideLoader, UserItem } = useContext(WarehouseContext);

  const [formData, setFormData] = useState({
    p_id: "",
    product_processing_id: "",
    packets: "",
    user_id: UserItem?.user_id || 1,
    warehouse_id: "",
    date_time: new Date().toISOString().slice(0, 16).replace('T', ' '),
    box_qty: "",
    box_sales: "",
    mfg_date: new Date().toISOString().slice(0, 10),
    expiry_date: "",
    remarks: "",
    shop_id: UserItem?.shop_id || 1,
    created_by: UserItem?.user_id || 1,
  });

  const [errors, setErrors] = useState({});
  const [products, setProducts] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [ingredients, setIngredients] = useState([]);
  const [selectedProductIndex, setSelectedProductIndex] = useState(null);

  useEffect(() => {
    // Fetch products and warehouses for dropdowns
    fetchProductsList();
    fetchWarehousesList();

    if (selectedProduct && !AddorEdit) {
      // Edit mode
      setFormData({
        p_id: selectedProduct?.p_id || "",
        packets: selectedProduct?.qty || "",
        product_processing_id: selectedProduct?.isProductSelected || "",
        user_id: selectedProduct?.user_id || UserItem?.user_id || 1,
        warehouse_id: selectedProduct?.warehouse_id || "",
        box_qty: selectedProduct?.box_qty || "",
        box_sales: selectedProduct?.box_sales || "",
        mfg_date: selectedProduct?.mfg_date || new Date().toISOString().slice(0, 10),
        expiry_date: selectedProduct?.expdate || "",
        remarks: selectedProduct?.remarks || "",
        shop_id: selectedProduct?.shop_id || UserItem?.shop_id || 1,
        created_by: selectedProduct?.created_by || UserItem?.user_id || 1,
      });
    }
  }, [selectedProduct, AddorEdit]);

  useEffect(() => {
    if (formData.p_id) {
      fetchIngredients(formData.p_id);
    }
  }, [formData.p_id]);

  const fetchIngredients = async (productId) => {
    try {
      const response = await get_product_ingredients({}, productId);
      console.log("Ingredients response:", response.data);
      if (response.data && response.data.data) {
        // Ensure ingredients data is properly structured
        const ingredientsData = response.data.data.map(item => {
          // Handle ingrident parsing safely
          let parsedIngredients = [];
          if (item.ingrident) {
            try {
              // Check if ingrident is already an array or needs to be parsed
              parsedIngredients = typeof item.ingrident === 'string' 
                ? JSON.parse(item.ingrident) 
                : item.ingrident;
            } catch (error) {
              console.error("Error parsing ingredients:", error);
              parsedIngredients = [];
            }
          }
          
          return {
            ...item,
            ingrident: parsedIngredients
          };
        });
        
        setIngredients(ingredientsData);
      }
    } catch (error) {
      console.error("Error fetching product ingredients:", error);
      toast.error("Failed to load ingredients for this product");
      setIngredients([]);
    }
  };

  const fetchProductsList = async () => {
    try {
      const response = await getProductMaster();
      if (response.data && response.data.data) {
        setProducts(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      toast.error("Failed to load products");
    }
  };

  const fetchWarehousesList = async () => {
    // Commented as in original code
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoader();

    const validationErrors = {};
    if (!formData.p_id) validationErrors.p_id = "Product is required.";
    if (!formData.packets) validationErrors.packets = "Number of packets is required.";
    if (!formData.expiry_date) validationErrors.expiry_date = "Expiry date is required.";
    if (!formData.product_processing_id) validationErrors.product_processing_id = "Please select a processing method.";

    // Validate expiry date is after manufacturing date
    if (formData.mfg_date && formData.expiry_date) {
      if (new Date(formData.expiry_date) <= new Date(formData.mfg_date)) {
        validationErrors.expiry_date = "Expiry date must be after manufacturing date.";
      }
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      hideLoader();
      return;
    }

    try {
      const payload = {
        p_id: formData.p_id,
        product_processing_id: formData.product_processing_id,
        packets: parseInt(formData.packets),
        user_id: parseInt(formData.user_id),
        warehouse_id: formData.warehouse_id || "",
        box_qty: formData.box_qty ? parseInt(formData.box_qty) : "",
        box_sales: formData.box_sales ? parseFloat(formData.box_sales) : "",
        mfg_date: formData.mfg_date,
        expiry_date: formData.expiry_date,
        remarks: formData.remarks || "",
        shop_id: parseInt(formData.shop_id),
        created_by: parseInt(formData.created_by),
      };

      await create_product_transection(payload);
      toast.success("End Product transaction created successfully");

      fetchProducts();
      handleCancel();
    } catch (error) {
      console.error("Error saving End product transaction:", error);
      toast.error(error?.response?.data?.message || "Error saving End product transaction");
    } finally {
      hideLoader();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const resetForm = () => {
    setFormData({
      p_id: "",
      packets: "",
      product_processing_id: "",
      user_id: UserItem?.user_id || 1,
      warehouse_id: "",
      box_qty: "",
      box_sales: "",
      mfg_date: new Date().toISOString().slice(0, 10),
      expiry_date: "",
      remarks: "",
      shop_id: UserItem?.shop_id || 1,
      created_by: UserItem?.user_id || 1,
    });
    setErrors({});
    setSelectedProductIndex(null);
    setIngredients([]);
  };

  const handleCancel = () => {
    setShowModal(false);
    resetForm();
  };

  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                  {AddorEdit ? "Add Product Transaction" : "Edit Product Transaction"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={handleCancel}
                ></button>
              </div>
              <div className="modal-body" style={{ fontFamily: "poppins" }}>
                <form onSubmit={handleSubmit} className="row g-3">
                  {/* Product Selection */}
                  <div className="col-md-12">
                    <label>
                      Product <span className="text-danger">*</span>
                    </label>
                    <select
                      name="p_id"
                      value={formData.p_id}
                      onChange={handleChange}
                      className={`form-control ${errors.p_id ? 'is-invalid' : ''}`}
                    >
                      <option value="">Select Product</option>
                      {products.map((product) => (
                        <option key={product.product_id} value={product.product_id}>
                          {product.title}
                        </option>
                      ))}
                    </select>
                    {errors.p_id && <div className="invalid-feedback">{errors.p_id}</div>}
                  </div>

                  {/* Number of Packets */}
                  <div className="col-md-6">
                    <label>Number of Packets <span className="text-danger">*</span></label>
                    <input
                      type="number"
                      name="packets"
                      value={formData.packets}
                      onChange={handleChange}
                      className={`form-control ${errors.packets ? 'is-invalid' : ''}`}
                      min="1"
                      placeholder="Enter number of packets"
                    />
                    {errors.packets && <div className="invalid-feedback">{errors.packets}</div>}
                  </div>

                  {/* Expiry Date */}
                  <div className="col-md-6">
                    <label>Expiry Date <span className="text-danger">*</span></label>
                    <input
                      type="date"
                      name="expiry_date"
                      value={formData.expiry_date}
                      onChange={handleChange}
                      className={`form-control ${errors.expiry_date ? 'is-invalid' : ''}`}
                      min={formData.mfg_date || new Date().toISOString().split('T')[0]}
                    />
                    {errors.expiry_date && <div className="invalid-feedback">{errors.expiry_date}</div>}
                  </div>

                  {/* Ingredients Section */}
                  {ingredients.length > 0 ? (
                    <div className="col-md-12 mt-3">
                      <h6>Product Ingredients</h6>
                      {ingredients.map((product, pIndex) => (
                        <div key={`product-${pIndex}`} className="mb-4 p-3 border rounded">
                          <div className="d-flex align-items-center mb-2">
                            <input
                              type="checkbox"
                              id={`product-${pIndex}`}
                              checked={selectedProductIndex === pIndex}
                              disabled={selectedProductIndex !== null && selectedProductIndex !== pIndex}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedProductIndex(pIndex);
                                  setFormData({
                                    ...formData,
                                    product_processing_id: product.product_processing_id
                                  });
                                  // Clear the error if exists
                                  setErrors(prev => ({
                                    ...prev,
                                    product_processing_id: ""
                                  }));
                                } else {
                                  setSelectedProductIndex(null);
                                  setFormData({
                                    ...formData,
                                    product_processing_id: ""
                                  });
                                }
                              }}
                              className="form-check-input me-2"
                            />
                            <label htmlFor={`product-${pIndex}`} className="form-check-label fw-bold">
                              {product.product_name} - Total Quantity: {product.quantity} {product.units}
                            </label>
                          </div>

                          {selectedProductIndex === pIndex && Array.isArray(product.ingrident) && product.ingrident.length > 0 && (
                            <div className="table-responsive mt-2">
                              <table className="table table-sm table-bordered">
                                <thead className="bg-light">
                                  <tr>
                                    <th>Ingredient Name</th>
                                    <th>Packet Quantity</th>
                                    <th>Unit</th>
                                    <th>Total (User Packets × Qty)</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {product.ingrident.map((ing, index) => {
                                    const total =
                                      formData.packets && ing.qty
                                        ? parseFloat(formData.packets) * parseFloat(ing.qty)
                                        : 0;

                                    return (
                                      <tr key={`ing-${index}`}>
                                        <td>{ing.title}</td>
                                        <td>{ing.qty}</td>
                                        <td>{ing.unit}</td>
                                        <td>{total.toFixed(2)}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      ))}
                      {errors.product_processing_id && (
                        <div className="text-danger mb-3">{errors.product_processing_id}</div>
                      )}
                    </div>
                  ) : formData.p_id ? (
                    <div className="col-md-12 mt-3">
                      <div className="alert alert-info">
                        No processing methods found for this product. Please select a different product or add processing methods first.
                      </div>
                    </div>
                  ) : null}

                  <div className="col-12 text-end mt-4">
                    <button type="submit" className="btn btn-primary">
                      {AddorEdit ? "Create Transaction" : "Update Transaction"}
                    </button>
                    &nbsp;&nbsp;
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
